import { CxEvent } from '@spartacus/core';

export class FbqGgUserRegistrationSuccessEvent extends CxEvent {
  event?: string;
}
